import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ENewAnswerForm {
  Clear = 'NEW_ANSWER/FORM/CLEAR',
}

export type TNewReviewClear = ITypedReduxAction<ENewAnswerForm.Clear>;

export const clearNewAnswerFormAction = actionGenerator<ENewAnswerForm.Clear>(ENewAnswerForm.Clear);

export type TNewAnswerFormActions = TNewReviewClear;
